import { useEffect, useRef } from "react";
import { hotkeyEventListener } from "@/lib/hotkeyEventListener";

type Props = {
    legacyUrl: string;
};

export default function Iframe({ legacyUrl }: Props) {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    //NOTE: if you open adminManager with autofill, the autofill will continue in the searchParams
    //This is an annoying issue to fix, so #wontfix
    const searchParams = location.search ?? '';
    const hashParams = location.hash ?? '';

    //Listens to hotkeys in the iframe
    useEffect(() => {
        if (!iframeRef.current) return;
        iframeRef.current.contentWindow?.addEventListener('keydown', hotkeyEventListener);
    }, []);

    const markEmbedded = () => {
        const frameDoc = iframeRef.current?.contentDocument;
        if (!frameDoc || frameDoc.URL === 'about:blank') return;
        frameDoc.documentElement.classList.add('embedded-in-panel');
    };

    useEffect(() => {
        const wanted = `/legacy/${legacyUrl}`;
        let handle = 0;
        let ticks = 0;
        const watch = () => {
            markEmbedded();
            const frameDoc = iframeRef.current?.contentDocument;
            const arrived = !!frameDoc
                && frameDoc.URL.includes(wanted)
                && frameDoc.readyState === 'complete';
            if (arrived || ++ticks > 600) return;
            handle = window.setTimeout(watch, 16);
        };
        watch();
        return () => clearTimeout(handle);
    }, [legacyUrl]);

    return (
        <iframe
            ref={iframeRef}
            id="legacyPageIframe" //required for the theme switcher
            src={`./legacy/${legacyUrl}${searchParams}${hashParams}`}
            onLoad={markEmbedded}
            className="w-full"
        ></iframe>
    );
}
